export default angular
  .module('doxy.common.directives.autoFocus', [])
  .directive('dAutoFocus', function ($timeout) {
    return {
      restrict: 'A',
      scope: false,
      link: function (scope, $element) {
        $timeout(function () {
          $element[0].focus();
        }, 200);
      },
    };
  }).name;
